<template>
  <div class="SidebarLayout-styles-content">
    <h2 class="SettingsDesktopContainer-styles-desktop-title">{{ t.navigation.prefences }}</h2>
    <div class="Paper-styles-paper">
      <div class="SettingsDesktop-styles-container">
        <symForm :options="opt" :data="formData" v-on:sended="getUserForm" :form="userForm" :formProcess="formProcess" v-if="userForm" />
      </div>
    </div>
  </div>
</template>

<script>

    import symForm from '@/components/form/symForm.vue'
    import globalLoader from '@/components/ui/loader/globalLoader.vue'
    export default {
        name: 'prefences',
        components: { symForm, globalLoader },
        data () {
            return {
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                userForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: []
            }
        },
        mounted () {
            this.getUserForm();
            this.fetchRegions();
            this.fetchUserGroup();
        },
        methods: {

            async getUserForm (data) {

                if(this.session.uid > 0) {
                    this.userForm = null;
                    this.formProcess = 0;
                    this.$bus.$emit('globalLoader', 1);
                    if(data) {
                        //this.userForm = null;
                        this.$http.post(api+'api/v1/user/prefences/form',
                            data )
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formProcess = 200;

                                swal('', this.t.processing.success, "success")
                                this.$bus.$emit('globalLoader', 0);

                            }, response => {
                                this.userForm = response.body.result;
                                this.formProcess = 400;
                                swal(this.t.processing.error, this.t.processing.check, "error")
                                this.$bus.$emit('globalLoader', 0);
                            })

                    } else {
                        this.$http.get(api+'api/v1/user/prefences/form')
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formData = response.body.form_data;
                                this.$bus.$emit('globalLoader', 0);

                            }, response => {
                                this.$bus.$emit('globalLoader', 0);
                            })
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/account/prefences.vue